import React, { createContext, useContext, useState, useCallback, useMemo, ReactNode } from 'react';

type TContact = {
  id: number,
  created_at: string,
  name: string,
  uid: string,
  address: string,
  document_type: string,
  document_number: string,
  email: string,
  phone: string,
  requires_electronic_invoice: boolean,
}

type TContactContext = {
  list: TContact[],
  current: TContact,
  showModal: boolean,
}
const initialState:TContactContext =  {
  list: [],
  current: {
    name: '',
    uid: '',
    created_at: "",
    id: 0,
    address: '',
    document_type: '',
    document_number: '',
    email: '',
    phone: '',
    requires_electronic_invoice: false,
  },
  showModal: false,
}
interface ContactContextType {
  contact: TContactContext;
  updateContact: (newConfig: Partial<TContactContext>) => void;
}
interface UserContactProps {
  children: ReactNode;
}

const ContactContext = createContext<ContactContextType>({contact:initialState,updateContact:()=>{}});

export const ContactProvider:React.FC<UserContactProps> = ({ children }) => {
  const [contact, setContact] = useState(initialState);
  const updateContact = useCallback((newConfig:Partial<TContactContext>) => {
    setContact((prevConfig) => ({ ...prevConfig, ...newConfig }));
  }, []);
  
  const contextValue = useMemo(() => ({
    contact,
    updateContact,
  }), [contact, updateContact]);

  return (
    <ContactContext.Provider value={contextValue}>
      {children}
    </ContactContext.Provider>
  );
};

export const useContact = () => {
  return useContext(ContactContext);
};